import { Component, Input } from '@angular/core';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  RolloverResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover.result';

@Component({
  selector: 'app-rollover-share-capital-result',
  templateUrl: './rollover-share-capital-result.component.html',
  styleUrls: ['./rollover-share-capital-result.component.scss'],
  standalone: false,
})
export class RolloverShareCapitalResultComponent {

  @Input()
  options: RolloverOptions;
  @Input()
  results: RolloverResult;

  isSectionCollapsed: boolean = false;

}
